import { useQuery } from '@tanstack/react-query';

import { $apiV2 } from 'modules/global';

import { IFeedbackReasons } from '../models';
import { proConst } from '..';

export const useFeedbackReasons = () => {
  const { data, ...args } = useQuery({
    queryKey: [proConst.queryKeys.FEEDBACK_REASONS],
    queryFn: async () => {
      const { data } = await $apiV2.get<IFeedbackReasons>('/payment-feedback-reason/select');

      return { reasons: data?.data };
    }
  });

  return { ...data, ...args };
};
